import { create } from '@wix/fedops-logger';

export const createFedopsLogger = () => {
  return create('wix-chatbot-client');
};
